import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LabelList,
} from "recharts";

const CurrentBinning = () => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    const storedData = JSON.parse(sessionStorage.getItem("shipmentData"));

    if (storedData && Array.isArray(storedData.shipment_data)) {
      const formattedData = storedData.shipment_data.map((shipment) => {
        const i1 = shipment.binning_counts?.I1 || 0;
        const i2 = shipment.binning_counts?.I2 || 0;
        const i3 = shipment.binning_counts?.I3 || 0;
        const total = i1 + i2 + i3;

        return {
          supplier_name: `${shipment.supplier_name || "Unknown Supplier"} (${
            shipment.module_wattage || "N/A"
          })`,
          i1,
          i2,
          i3,
          total,
        };
      });

      setChartData(formattedData);
    } else {
      console.error("Invalid or missing shipment_data:", storedData);
      setChartData([]);
    }
  }, []);

  const renderCustomLabel = (props) => {
    const { x, y, width, height, value, dataKey, fill, index } = props;

    const item = chartData[index];
    const total = item?.total || 0;

    if (!value || total === 0) return null;

    const percent = ((value / total) * 100).toFixed(2);

    return (
      <text
        x={x + width / 2}
        y={y + height / 2}
        fill={fill}
        fontSize={12}
        fontWeight="bold"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        {value} ({percent}%)
      </text>
    );
  };

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const i1 = payload.find((p) => p.dataKey === "i1")?.value || 0;
      const i2 = payload.find((p) => p.dataKey === "i2")?.value || 0;
      const i3 = payload.find((p) => p.dataKey === "i3")?.value || 0;
      const total = i1 + i2 + i3;

      return (
        <div
          style={{
            backgroundColor: "#ffffff",
            padding: "10px",
            border: "1px solid #ccc",
            borderRadius: "5px",
            fontSize: "14px",
          }}
        >
          <p style={{ color: "#B0E0E6" }}>i1: {i1}</p>
          <p style={{ color: "#5A7391" }}>i2: {i2}</p>
          <p style={{ color: "#8EACE3" }}>i3: {i3}</p>
          <p style={{ color: "#333" }}>
            <strong>Total: {total}</strong>
          </p>
        </div>
      );
    }

    return null;
  };

  return (
    <div style={{ padding: "2rem" }}>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
          layout="vertical"
        >
          <XAxis type="number" />
          <YAxis type="category" dataKey="supplier_name" />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
          <Bar dataKey="i1" stackId="a" fill="#B0E0E6" barSize={70}>
            <LabelList
              dataKey="i1"
              position="insideRight"
              fill="black"
              content={renderCustomLabel}
            />
          </Bar>
          <Bar dataKey="i2" stackId="a" fill="#5A7391" barSize={70}>
            <LabelList
              dataKey="i2"
              position="insideRight"
              fill="white"
              content={renderCustomLabel}
            />
          </Bar>
          <Bar dataKey="i3" stackId="a" fill="#8EACE3" barSize={70}>
            <LabelList
              dataKey="i3"
              position="right"
              fill="black"
              content={renderCustomLabel}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CurrentBinning;